.title {
  font-weight: 500;
}

.header {
  margin-bottom: 8px;
}

.content {
  padding-bottom: 16px !important;
}
